import axios from 'axios'
import {
  AppRole,
  AppRoleErrorCode,
  AppRoleMembersResponse,
  MyAppRoleResponse,
} from '../types/rbac.types'

const BACKEND_URL = process.env.REACT_APP_BACKEND_API_URL + '/api/v1'

const KNOWN_ERROR_CODES: AppRoleErrorCode[] = [
  'forbidden',
  'not_member_of_account',
  'last_admin',
  'busy_retry',
  'managed_by_8000_role',
  'invalid_role',
  'invalid_user',
  'rbac_unavailable',
]

// Erreur typée : le code backend (`{"error": "..."}`) est conservé pour que
// l'UI affiche un message français ciblé sans inspecter la réponse axios.
export class AppRoleError extends Error {
  code: AppRoleErrorCode
  status?: number

  constructor(code: AppRoleErrorCode, status?: number) {
    super(code)
    this.name = 'AppRoleError'
    this.code = code
    this.status = status
  }
}

const toAppRoleError = (err: any): AppRoleError => {
  const status: number | undefined = err?.response?.status
  // 401 = session expirée / JWT invalide, quel que soit le corps de réponse.
  if (status === 401) return new AppRoleError('unauthorized', status)
  const raw = err?.response?.data?.error
  const code = KNOWN_ERROR_CODES.includes(raw) ? (raw as AppRoleErrorCode) : 'unknown'
  return new AppRoleError(code, status)
}

export const getMyAppRole = async (): Promise<MyAppRoleResponse> => {
  try {
    const res = await axios.get<MyAppRoleResponse>(`${BACKEND_URL}/me/app-role`)
    return {
      appRole: res.data?.appRole ?? '',
      capabilities: Array.isArray(res.data?.capabilities) ? res.data.capabilities : [],
    }
  } catch (err) {
    throw toAppRoleError(err)
  }
}

export const getAppRoleMembers = async (): Promise<AppRoleMembersResponse> => {
  try {
    const res = await axios.get<AppRoleMembersResponse>(`${BACKEND_URL}/app-roles`)
    return { accountID: res.data?.accountID ?? '', members: res.data?.members ?? [] }
  } catch (err) {
    throw toAppRoleError(err)
  }
}

export const updateAppRole = async (targetUserId: string, appRole: AppRole): Promise<void> => {
  try {
    await axios.put(`${BACKEND_URL}/app-roles/${encodeURIComponent(targetUserId)}`, { appRole })
  } catch (err) {
    throw toAppRoleError(err)
  }
}

export const rbacAPI = { getMyAppRole, getAppRoleMembers, updateAppRole }
export default rbacAPI
